<template>
  <v-btn class="font-weight-bold"
         :outlined="outline"
         @click="click"
         :block="block"
         :color="primaryColor"
         :to="to"
         dark
         large>
    {{ text }}
    <v-icon v-if="icon"
            small
            class="ml-2">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "vue-ongeo-button",
  props: {
    primaryColor: String,
    text: String,
    to: String | Object,
    block: { type: Boolean, default: false },
    click: { type: Function, default: function () { } },
    icon: { type: String, default: null },
    outline: { type: Boolean, default: false }
  }
};
</script>
